import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as previousOccupier from '../previous-occupier'

// NOTE: a DMS query given a period filters every record, snapshots included,
// by its active periods. Each previous occupier is logged as active from the
// start of the scenario it was logged in, so a scenario only reads its own and
// the earlier scenarios' previous occupiers
export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: previousOccupier.RESOURCE.payload.dimension.partialId,
      partialId: previousOccupier.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Snapshot,
    }),
    default: '{(,)}',
    description: 'Space previous occupier active periods',
    isOptional: false,
    name: 'Active Period(s)',
    partialId: PartialId.Standard.create('active_periods'),
    type: core.common.value.types.Intrinsic.DateMultirange,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
